
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProjectLoading } from "@/components/project/ProjectLoading";
import { ProjectNotFound } from "@/components/project/ProjectNotFound";
import { ProjectDetailContent } from "@/components/project/ProjectDetailContent";
import { useProjectDetails } from "@/hooks/useProjectDetails";

export default function ProjectDetail() {
  const { projectId } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const { project, isLoading } = useProjectDetails(projectId);

  if (isLoading) {
    return <ProjectLoading />;
  }

  if (!project) {
    return <ProjectNotFound />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ProjectDetailContent project={project} />
    </div>
  );
}
